import { Component } from "@angular/core";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { BaseDialogComponent, DialogResolveData } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";

@Component({
    selector: "adapt-update-invoice-payment-method-dialog",
    templateUrl: "./update-invoice-payment-method-dialog.component.html",
    standalone: false,
})
export class UpdateInvoicePaymentMethodDialogComponent extends BaseDialogComponent<void> {
    public readonly dialogName = "UpdateInvoicePaymentMethodDialog";
    public readonly ProjectLabel = AdaptClientConfiguration.AdaptProjectLabel;

    public constructor() {
        super(DialogResolveData.NotRequired);
    }
}
